import { FC } from 'react';
import { PredefinedColors } from '@ionic/core';
import { IonButton, IonIcon } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';

export const MenuBackButton: FC<{
    onClick?: () => void;
    color?: PredefinedColors;
}> = ({ onClick, color }) => {
    return (
        <IonButton
            color={color}
            fill="clear"
            shape="round"
            onClick={onClick}
            data-id="back-button"
            style={{'--padding-start': '12px', '--padding-end': '12px', minHeight: 42, minWidth: 42, marginLeft: 6}}
        >
            <IonIcon icon={arrowBack} />
        </IonButton>
    );
};
